(function () {
    'use strict';

    angular.module('swif.ui')
    .config(route)
    .controller('TestsBugController', TestsBugController)
    .controller('TestsFormsController', TestsFormsController)
    .controller('TestsVocabulariesController', TestsVocabulariesController)
    .controller('TestsFiltersController', TestsFiltersController)
    .controller('TestsMenuController', TestsMenuController);

    function route ($routeProvider) {
        'ngInject';
        $routeProvider.when('/tests', {
            templateUrl: 'partials/ui/tests/index.html'
        });
        $routeProvider.when('/tests/forms', {
            templateUrl: 'partials/ui/tests/forms.html',
            controller: 'TestsFormsController'
        });
        $routeProvider.when('/tests/menu', {
            templateUrl: 'partials/ui/tests/menu.html',
            controller: 'TestsMenuController'
        });
        $routeProvider.when('/tests/bug', {
            templateUrl: 'partials/ui/tests/bug.html',
            controller: 'TestsBugController'
        });
        $routeProvider.when('/tests/vocabularies', {
            templateUrl: 'partials/ui/tests/vocabularies.html',
            controller: 'TestsVocabulariesController'
        });
        $routeProvider.when('/tests/filters', {
            templateUrl: 'partials/ui/tests/filters.html',
            controller: 'TestsFiltersController'
        });
        $routeProvider.when('/tests/barcode', {
            templateUrl: 'partials/ui/tests/barcode.html'
        });
    }


    function TestsMenuController ($scope, $location, swif) {
        'ngInject';
        console.log('init TestsMenuController');
        $scope.updateGroups = updateGroups;

        function updateGroups() {
            //hack drop the user.id
            var user = swif.settings.get('authenticated_user');
            delete user.id;
            swif.settings.set('authenticated_user', user);
            swif.user._setAuthenticatedUserData();
        }
    }

    function TestsBugController ($scope) {
        'ngInject';
        console.log('init TestsFormsController');
        $scope.model = {
            date: '2014-12-30',
            datetime: '2014-12-30 09:00:00',
            time: 1.75,
            duration: 1.75
        };
    }

    function TestsFormsController($scope) {
        'ngInject';
        console.log('init TestsFormsController');
        $scope.resetModel = function () {
            $scope.model = {};
        };
        $scope.fillModel = function () {
            $scope.model = {
                bool: true,
                text: 'text',
                tel: '02 02 02 02 02',
                email: 'dupont@laposte.net',
                selected: [0, 'first'],
                multiSelected: [0, 1],
                textarea: 'text\narea',
                date: '2014-12-30',
                datetime: '2014-12-30 09:00:00',
                time: 1.75,
                duration: 1.75,
                currency: 1000.53,
                number: 14
            };
        };
        $scope.resetModel();
        $scope.choices = [{id: 0, name: 'first'}, {id: 1, name: 'second'}];
        $scope.isRequired = false;
        $scope.toggleRequired = function () {
            $scope.isRequired = !$scope.isRequired;
        };
        $scope.toggleDisabled = function () {
            $scope.isDisabled = !$scope.isDisabled;
        };
    }

    function TestsVocabulariesController($scope, dataService) {
        'ngInject';
        console.log('init TestsFormsController');
        $scope.loading = {};
        $scope.resetVocabulary = function (vocabulary) {
            delete $scope.vocabularies[vocabulary];
        };
        $scope.loadVocabulary = function (vocabulary) {
            $scope.loading[vocabulary] = true;
            var params = {};
            params[vocabulary] = true;
            dataService.getVocabularies(params).then(function (vocab) {
                $scope.loading[vocabulary] = false;
                $scope.vocabularies[vocabulary] = vocab[vocabulary];
            });
        };
        var allVocabularies = {
            consumable: true,
            consumable_category: true,
            department: true,
            equipment: true,
            intervention_category: true,
            partner: true,
            partner_address: true,
            site: true,
            task_category: true,
            team: true
        };
        $scope.loadVocabularies = function () {
            $scope.loading.all = true;
            dataService.getVocabularies(allVocabularies).then(function (vocab) {
                $scope.loading.all = false;
                $scope.vocabularies = vocab;
            });
        };
        $scope.resetVocabularies = function () {
            $scope.vocabularies = {};
        };
        $scope.resetVocabularies();
    }

    function TestsFiltersController($scope, $location, collections) {
        'ngInject';
        console.log('init TestsFiltersController');
        $scope.options = {
            type: 'intervention_request',
            textFields: ['name', 'description'],
            debug: true
        };
        collections.addCollection(
            'requests',
            'intervention_request',
            {domain: [['date_deadline', '=', 'OUTDATED']]}
        ).then(function () {
            collections.addCollectionToScope('requests', $scope); // $scope.requests
        });

        $scope.resetModel = function () {
            if ($scope.requests) {
                $scope.requests.currentFilter = {};
            }
        };
        $scope.fillModel = function () {

        };
    }

})();